module.exports = __webpack_public_path__ + "assets/close-icon.835a4b8652ca5c3da3cf8b1189d0e26b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/close-icon.png
// module id = 118
// module chunks = 0